import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots, resolveDirective as _resolveDirective, renderList as _renderList } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle.svg'


const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "w-3/4 grid gap-6 grid-cols-2" }
const _hoisted_3 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_4 = { class: "flex flex-row ml-1" }
const _hoisted_5 = {
  key: 0,
  "data-testid": "handover-vendor-option-api-badge",
  class: "ml-1 bg-red-lp-3000 rounded-2xl text-center text-red-lp-2400 font-medium text-xs px-2 py-0.5",
  style: {"line-height":"100%"}
}
const _hoisted_6 = { class: "flex flex-row ml-1" }
const _hoisted_7 = {
  key: 0,
  "data-testid": "handover-vendor-selected-api-badge",
  class: "ml-1 bg-red-lp-3000 rounded-2xl text-center text-red-lp-2400 font-medium text-xs px-2 py-0.5",
  style: {"line-height":"100%"}
}
const _hoisted_8 = { class: "w-2/12" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_10 = { class: "flex items-end justify-between" }
const _hoisted_11 = { class: "flex gap-x-16" }
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = { class: "font-semibold text-black-lp-300" }
const _hoisted_14 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_15 = { class: "space-y-2" }
const _hoisted_16 = { class: "font-semibold text-black-lp-300" }
const _hoisted_17 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_18 = { class: "space-y-2" }
const _hoisted_19 = { class: "font-semibold text-black-lp-300" }
const _hoisted_20 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = { class: "font-semibold text-black-lp-300" }
const _hoisted_23 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_24 = { class: "flex gap-x-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = { class: "flex-col grid col-gap-2 grid-cols-8 justify-center w-full mt-2" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_29 = { class: "col-span-4 space-y-1" }
const _hoisted_30 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "check-circle"
}, null, -1)
const _hoisted_32 = { class: "text-12px text-black-lp-300" }
const _hoisted_33 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "x-circle"
}, null, -1)
const _hoisted_35 = { class: "text-12px text-black-lp-300" }
const _hoisted_36 = { class: "font-semibold text-black-lp-300" }
const _hoisted_37 = { class: "flex flex-row" }
const _hoisted_38 = { class: "flex flex-col space-y-3" }
const _hoisted_39 = { class: "text-20px font-semibold text-black-lp-200" }
const _hoisted_40 = { class: "space-y-1" }
const _hoisted_41 = { class: "text-12px xxl:text-14px text-gray-lp-600 pr-12" }
const _hoisted_42 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_43 = { class: "text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "check-circle"
}, null, -1)
const _hoisted_45 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_46 = { class: "flex justify-end space-x-3" }
const _hoisted_47 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Print = _resolveComponent("Print")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_DetailLayout, {
        onBack: _ctx.goBack,
        title: _ctx.$t('handover.update.pageTitle'),
        "vertical-separator": false,
        "is-floating-action": true,
        fullPage: ""
      }, {
        data: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('handover.update.handoverTo.title')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  onFilter: _ctx.fetchPartnerVendor,
                  onFocus: _ctx.fetchPartnerVendor,
                  isLoading: _ctx.isLoadingPartnerVendor,
                  options: _ctx.partnerVendorList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: _ctx.$t('handover.update.handoverTo.placeholder'),
                  modelValue: _ctx.form.handoverName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.handoverName = $event)),
                  key: _ctx.form.handoverName,
                  onChange: _ctx.onChangePartnerVendor,
                  class: "mt-1.5"
                }, {
                  "custom-option": _withCtx(({ item }) => [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("div", null, _toDisplayString(item.name), 1),
                      _createVNode("div", _hoisted_4, [
                        (item.isApiIntegration)
                          ? (_openBlock(), _createBlock("span", _hoisted_5, " API "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  "selected-info": _withCtx(({ selected }) => [
                    _createVNode("div", _hoisted_6, [
                      (selected && selected.isApiIntegration)
                        ? (_openBlock(), _createBlock("span", _hoisted_7, " API "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.form.handoverName.value === 'vendorinternal')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: _ctx.$t('handover.update.vendorName.title')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      modelValue: _ctx.form.remarks,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.remarks = $event)),
                      type: "textarea",
                      placeholder: _ctx.$t('handover.update.vendorName.placeholder'),
                      textAreaRows: "1",
                      minLength: 5,
                      maxLength: 200,
                      format: _ctx.onlyAcceptedSomeChar
                    }, null, 8, ["modelValue", "placeholder", "format"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: _ctx.$t('handover.update.sttNumber.title')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  ref: "inputStt",
                  onEnter: _ctx.onValidateSttNumber,
                  sizeInput: "24px",
                  labelStacked: _ctx.$t('handover.update.sttNumber.label'),
                  modelValue: _ctx.form.sttNumber,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.sttNumber = $event)),
                  placeholder: _ctx.$t('handover.update.sttNumber.placeholder'),
                  bold: !!_ctx.form.sttNumber,
                  error: !_ctx.isPaid || _ctx.errorSttNumber !== '',
                  onChange: _cache[4] || (_cache[4] = () => {_ctx.isPaid = true; _ctx.onCloseNotification();}),
                  isErrorIconCaption: !_ctx.errorSttNumber,
                  isErrorIconInput: !_ctx.errorSttNumber,
                  errorCaption: 
                !_ctx.isPaid
                  ? _ctx.$t('handover.update.errorWeightExceeded')
                  : _ctx.errorSttNumber
              
                }, null, 8, ["onEnter", "labelStacked", "modelValue", "placeholder", "bold", "error", "isErrorIconCaption", "isErrorIconInput", "errorCaption"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.addSttNumber,
              customClass: "px-12 py-2.5",
              title: _ctx.$t('handover.update.add'),
              textColor: "white",
              disabled: _ctx.isDisableAddSttNumber
            }, null, 8, ["onClick", "title", "disabled"])
          ]),
          (_ctx.dataSttToBeUpdate.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('handover.update.sttInfo.totalStt')), 1),
                      _createVNode("div", _hoisted_14, _toDisplayString(_ctx.totalStt), 1)
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('handover.update.sttInfo.totalPieces')), 1),
                      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.totalPieces), 1)
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('handover.update.sttInfo.totalGrossWeight')), 1),
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.formatWeight(_ctx.totalGrossWeight)), 1)
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('handover.update.sttInfo.totalDimensionWeight')), 1),
                      _createVNode("div", _hoisted_23, _toDisplayString(_ctx.formatWeight(_ctx.totalVolumeWeight)), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode(_component_LpButton, {
                      outline: "",
                      iconLeft: "delete",
                      title: _ctx.$t('handover.update.sttInfo.delete'),
                      onClick: _ctx.onShowDelete,
                      textColor: "red-lp-300"
                    }, null, 8, ["title", "onClick"]),
                    _createVNode(_component_LpButton, {
                      onClick: _ctx.togglePanel,
                      icon: 
                  _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
                ,
                      title: _ctx.$t('handover.update.sttInfo.process'),
                      textColor: "white",
                      disabled: _ctx.isDisabledSave
                    }, null, 8, ["onClick", "icon", "title", "disabled"]),
                    _createVNode(_component_OverlayPanel, {
                      ref: "op",
                      appendTo: "body",
                      style: {"width":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LpButton, {
                          class: "w-60",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createAndPrint(false))),
                          flat: "",
                          dense: "",
                          iconLeft: "handover",
                          title: _ctx.$t('handover.update.process.update')
                        }, null, 8, ["title"]),
                        _hoisted_25,
                        _createVNode(_component_LpButton, {
                          class: "w-full",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createAndPrint(true))),
                          flat: "",
                          dense: "",
                          iconLeft: "printer",
                          title: _ctx.$t('handover.update.process.print')
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_TableV2, {
                    data: _ctx.dataSttToBeUpdate,
                    columns: _ctx.columns,
                    borderTop: false,
                    pagination: _ctx.pagination,
                    "is-hard-pagination": true,
                    "is-quick-search": true,
                    "is-sorting": true,
                    "pagination-style": "v2",
                    isPinnedScrollBottom: false,
                    isRightFreeze: "",
                    "total-column-freeze": 0
                  }, null, 8, ["data", "columns", "pagination"])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onBack", "title"])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onDownload : _ctx.alertPopup.onClick
    ,
      onClose: _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onClick : () => {},
      title: _ctx.alertPopup.title,
      message: _ctx.alertPopup.message,
      image: _ctx.alertPopup.image,
      textSuccess: _ctx.isPartial || _ctx.isFailed ? 'Download' : 'OK',
      textCancel: _ctx.isPartial || _ctx.isFailed ? 'OK' : '',
      class: "px-8",
      customButton: _ctx.isPartial || _ctx.isFailed ? 'px-10' : 'px-6'
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("div", _hoisted_29, [
            _withDirectives(_createVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("div", _hoisted_32, _toDisplayString(`${_ctx.countSuccess} ${_ctx.$t('handover.update.onUpdate.noSttSuccess')}`), 1)
            ], 512), [
              [_vShow, _ctx.isPartial]
            ]),
            _withDirectives(_createVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("div", _hoisted_35, _toDisplayString(`${_ctx.countFailed} ${_ctx.$t('handover.update.onUpdate.noSttFailed')}`), 1)
            ], 512), [
              [_vShow, _ctx.isPartial || _ctx.isFailed]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]), [
      [_vShow, _ctx.openSuccess || _ctx.isFailed || _ctx.isPartial || _ctx.isErrorValidationScan]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('handover.update.leave.title'),
      message: _ctx.$t('handover.update.leave.message'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('handover.update.leave.textSuccess'),
      textCancel: _ctx.$t('handover.update.leave.textCancel'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.handleConfirmationSave,
      title: _ctx.$t('handover.update.confirmation.title'),
      message: _ctx.$t('handover.update.confirmation.message'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('handover.update.confirmation.textSuccess'),
      textCancel: _ctx.$t('handover.update.confirmation.textCancel'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.notification = $event)),
      onClose: _ctx.onCloseNotification,
      data: _ctx.detailSttNotification,
      status: _ctx.isUnpaidNotification ? 'error' : 'success',
      hasChild: _ctx.isDuplicateScan
    }, _createSlots({ _: 2 }, [
      (_ctx.isDuplicateScan)
        ? {
            name: "content",
            fn: _withCtx(() => [
              _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("STT Sudah Di Scan")), 1)
            ])
          }
        : undefined
    ]), 1032, ["modelValue", "onClose", "data", "status", "hasChild"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showDeleteSttNumber,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteSttNumber = $event)),
      persistent: true,
      onReset: _ctx.onCloseDelete
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_37, [
          _createVNode("img", {
            src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
            class: "w-40 mr-12",
            alt: "delete-success"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('handover.update.removePieces.title')), 1),
            _createVNode("div", _hoisted_40, [
              _withDirectives(_createVNode("div", _hoisted_41, null, 512), [
                [_directive_sanitize_html, _ctx.$t('handover.update.removePieces.message')]
              ]),
              _createVNode(_component_LpInput, {
                ref: "deleteStt",
                error: !!_ctx.errorSttNumberDelete,
                errorCaption: _ctx.errorSttNumberDelete,
                onEnter: _ctx.onValidateDeleteSttNumber,
                modelValue: _ctx.sttNumberToDelete,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sttNumberToDelete = $event))
              }, null, 8, ["error", "errorCaption", "onEnter", "modelValue"])
            ]),
            (_ctx.sttNumberListTrash.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('handover.update.removePieces.removed')), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex flex-row",
                      key: item
                    }, [
                      _hoisted_44,
                      _createVNode("div", _hoisted_45, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_46, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onCloseDelete,
            customClass: "px-10 py-2",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('handover.update.removePieces.cancel'),
            class: "mt-10"
          }, null, 8, ["onClick", "title"]),
          _createVNode(_component_LpButton, {
            disabled: !_ctx.sttNumberToDelete,
            onClick: _ctx.onDeleteSttNumber,
            customClass: "px-10 py-2",
            textColor: "white",
            title: _ctx.$t('handover.update.removePieces.delete'),
            class: "mt-10"
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onReset"]),
    _createVNode("img", {
      id: "logo",
      src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
      class: "hidden",
      alt: "logo"
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_47, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
}